import { getHostWithoutSubdomain } from './util';

const apiUri = process.env.NX_PUBLIC_API_URI as string;

export type ConciergeLoginProviders = 'google' | 'applogin';

interface ConciergeConfig {
  apiUri: string;
  oauthUrls: {
    [key in ConciergeLoginProviders]: {
      init: string;
      callback: string;
      quickLogin?: string;
    };
  };
}

// OAuth logins are always redirected to the app subdomain,
// because google doesnt allow wildcard redirects
const oauthRedirectOrigin =
  process.env.NODE_ENV === 'development'
    ? window.location.origin
    : `${window.location.protocol}//app.${getHostWithoutSubdomain()}`;

const APPLOGIN_CLIENT_ID = process.env.NODE_ENV === 'development' ? '12' : '9';

const APPLOGIN_URL =
  process.env.NODE_ENV === 'development' ? 'https://staging.applogin.com' : 'https://applogin.com';

const conciergeConfig: ConciergeConfig = {
  apiUri,
  oauthUrls: {
    google: {
      init: `${apiUri}/connect/google?callback=${oauthRedirectOrigin}/auth/callback/google`,
      callback: `${apiUri}/auth/google/callback`,
    },
    applogin: {
      init: `${APPLOGIN_URL}/login?redirect_uri=${oauthRedirectOrigin}/auth/callback/applogin&client_id=${APPLOGIN_CLIENT_ID}&scope=openid&response_type=code`,
      quickLogin: `${APPLOGIN_URL}/oauth/authorize?redirect_uri=${oauthRedirectOrigin}/auth/callback/applogin&client_id=${APPLOGIN_CLIENT_ID}&scope=openid&response_type=code`,
      callback: `${apiUri}/auth/applogin/callback`,
    },
  },
};

export function getConciergeConfig() {
  return conciergeConfig;
}
